import { useComparer } from '@/hooks/useComparer';
import { useExpandable } from '@/hooks/useExpandable';
import { useProgressiveList } from '@/hooks/useProgressiveList';
import { ComparerCommon } from '@/types/comparer';
import { type FC } from 'react';
import { getVisibleItems, getVisibleParams } from '../comparerUtils/comparerUtils';
import ModifiedProps from '../comparerShared/ModifiedProps';
import StatusRow from '../comparerShared/StatusRow';

type CommonChangesProps = {
  categories: ComparerCommon[];
};

const CommonChange: FC<{ category: ComparerCommon }> = ({ category }) => {
  const { showUnchanged } = useComparer();
  const [open, setOpen] = useExpandable(category.status === 'modified');

  const visibleParams = getVisibleParams(category.changedProps, showUnchanged);
  const expandable = visibleParams.length > 0;

  return (
    <>
      <StatusRow
        status={category.status}
        title={category.label}
        label={category.label}
        open={open}
        setOpen={expandable ? setOpen : undefined}
      />
      {open &&
        expandable &&
        visibleParams.map((change, index) => <ModifiedProps key={`${change.key}-${index}`} param={change} />)}
    </>
  );
};

const CommonChanges: FC<CommonChangesProps> = ({ categories }) => {
  const { showUnchanged } = useComparer();

  const visibleCategories = useProgressiveList(getVisibleItems(categories, showUnchanged));

  return visibleCategories.map((category) => <CommonChange key={category.id} category={category} />);
};

export default CommonChanges;
